import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    schemesList: [],
    selectedScheme: null,
    lookupData: null,
    cataloguePreview: null,
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
};

const schemeSlice = createSlice({
    name: "scheme",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getSchemesSuccess: (state, action) => {
            state.schemesList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSchemeSuccess: (state, action) => {
            state.selectedScheme = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getLookupSuccess: (state, action) => {
            state.lookupData = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getCataloguePreviewSuccess: (state, action) => {
            state.cataloguePreview = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        stuffDone: (state) => {
            state.loading = false;
            state.error = null;
            state.response = null;
            state.statestatus = "added";
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
        },
        getError: (state, action) => {
            state.loading = false;
            const p = action.payload;
            state.error = typeof p === "string" ? p : p?.message || "Request failed";
        },
        underSchemeControl: (state) => {
            state.loading = false;
            state.response = null;
            state.error = null;
            state.statestatus = "idle";
            state.cataloguePreview = null;
        },
    },
});

export const {
    getRequest,
    getSchemesSuccess,
    getSchemeSuccess,
    getLookupSuccess,
    getCataloguePreviewSuccess,
    stuffDone,
    getFailed,
    getError,
    underSchemeControl,
} = schemeSlice.actions;

export const schemeReducer = schemeSlice.reducer;
